import { brand, neutral, semantic, surface, radius, shadow, typography } from "./tokens";

/**
 * Cấu hình antd DUY NHẤT của CMS, nạp ở RouterApp.
 *
 * Vì sao các seed trạng thái dùng biến thể `semantic.x` (bản đậm) chứ không phải
 * `xSolid`: antd lấy seed này vừa làm nền nút vừa làm CHỮ của Tag/Alert trên nền
 * nhạt. Đo thực tế trên nền tint tương ứng:
 *
 *   #16A66A / #EAF9F2 = 2,89   ->  #128555 / #EAF9F2 = 4,28
 *   #FF9D2E / #FFF5E8 = 1,93   ->  #A8681E / #FFF5E8 = 4,18
 *   chữ trắng / #FF0766 = 3,84 ->  chữ trắng / #E5065C đạt chuẩn
 *
 * Tông rực của bộ nhận diện (#16A66A, #FF9D2E, #FF0766) vẫn dùng, nhưng ở chỗ
 * mình tự kiểm soát được tương phản: thanh tiến độ, đường biểu đồ, chấm trạng
 * thái, ô icon — lấy qua `semantic.xSolid`.
 */
export const dashboardTheme = {
  token: {
    colorPrimary: brand.primary,
    colorInfo: semantic.info,
    colorSuccess: semantic.success,
    colorWarning: semantic.warning,
    colorError: semantic.danger,
    colorLink: brand.primary,

    colorTextBase: neutral[900],
    colorTextSecondary: neutral[500],
    colorTextTertiary: neutral[400],

    colorBgContainer: surface.card,
    colorBgLayout: surface.page,
    colorBorder: surface.divider,
    colorBorderSecondary: neutral[100],

    borderRadius: radius.md,
    borderRadiusLG: radius.md,
    borderRadiusSM: radius.base,

    fontFamily: typography.family,
    fontSize: typography.size.md,
    fontSizeHeading1: typography.size["3xl"],
    fontSizeHeading2: typography.size["2xl"],
    fontSizeHeading3: typography.size.xl,
    fontSizeHeading4: typography.size.lg,

    boxShadow: shadow.xs,
    boxShadowSecondary: shadow.sm,
    boxShadowTertiary: shadow.xs,

    motionDurationFast: "120ms",
    motionDurationMid: "180ms",
    motionDurationSlow: "240ms",
  },
  components: {
    Button: {
      borderRadius: radius.base,
      controlHeight: 36,
      fontWeight: 500,
      primaryShadow: "none",
      defaultShadow: "none",
    },
    Card: {
      borderRadiusLG: radius.md,
      boxShadowTertiary: shadow.xs,
      headerHeight: 52,
      headerHeightSM: 44,
      paddingLG: 24,
    },
    Table: {
      headerBg: neutral[50],
      headerColor: neutral[600],
      rowHoverBg: neutral[50],
      borderColor: neutral[100],
      headerBorderRadius: radius.base,
      cellPaddingBlock: 12,
      cellPaddingInline: 16,
    },
    Input: {
      borderRadius: radius.base,
      controlHeight: 36,
      activeBorderColor: brand.primary,
      hoverBorderColor: neutral[400],
    },
    Select: {
      borderRadius: radius.base,
      controlHeight: 36,
    },
    DatePicker: {
      borderRadius: radius.base,
      controlHeight: 36,
    },
    Modal: {
      borderRadiusLG: radius.md,
      titleFontSize: typography.size.lg,
      titleColor: neutral[900],
      colorBgMask: "rgba(15, 23, 42, 0.45)",
      boxShadow: shadow.md,
      headerBg: surface.card,
    },
    Tabs: {
      colorText: neutral[600],
      colorPrimary: brand.primary,
      itemSelectedColor: brand.primary,
      itemHoverColor: neutral[900],
      titleFontSize: typography.size.md,
    },
    Menu: {
      colorItemBgSelected: brand.primarySubtle,
      colorItemTextSelected: brand.primary,
      itemBorderRadius: radius.base,
      subMenuItemBorderRadius: radius.base,
      itemMarginInline: 6,
      itemPaddingInline: 12,
    },
    Tag: {
      borderRadiusSM: radius.sm,
      defaultBg: neutral[100],
      defaultColor: neutral[700],
    },
    Badge: {
      colorBgContainer: semantic.danger,
    },
    Breadcrumb: {
      fontSize: typography.size.base,
      itemColor: neutral[500],
      lastItemColor: neutral[900],
      linkColor: neutral[500],
      separatorColor: neutral[300],
    },
    Form: {
      labelFontSize: typography.size.base,
      labelColor: neutral[700],
      labelRequiredMarkColor: semantic.danger,
      itemMarginBottom: 20,
    },
    Divider: {
      colorSplit: neutral[100],
    },
    Pagination: {
      borderRadius: radius.base,
    },
    Spin: { colorPrimary: brand.primary },
    Switch: { colorPrimary: brand.primary },
    Notification: { borderRadiusLG: radius.md },
    Message: { borderRadiusLG: radius.base },
  },
};
